
import { create } from 'zustand';
import { ChatState } from './types';
import { createMessageOperations } from './messageOperations';
import { createReactionOperations } from './reactionOperations';
import { createReadStatusOperations } from './readStatusOperations';
import { createRealtimeOperations } from './realtimeOperations';

export const useChatStore = create<ChatState>((set, get) => {
  // Initial state
  const initialState = {
    messages: [],
    loading: false,
    unreadCount: 0,
    currentStoreId: null,
  };

  // Core operations
  const coreOperations = {
    setCurrentStoreId: (storeId: string) => {
      set({ currentStoreId: storeId });
    },
  };

  // Combine all operations
  return {
    ...initialState,
    ...coreOperations,
    ...createMessageOperations(set, get),
    ...createReactionOperations(set, get),
    ...createReadStatusOperations(set, get),
    ...createRealtimeOperations(set, get),
  };
});

// Re-export for backward compatibility
export * from './types';
